import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {FriedmanModule} from './FriedmanModule/friedman.module';
import {AppRoutingModule} from './app.routing.module';
import {CoreModule} from './CoreModule/core.module';
import {CommonModule} from '@angular/common';
import {HttpLink, HttpLinkModule} from 'apollo-angular-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {APOLLO_OPTIONS, ApolloModule} from 'apollo-angular';
import {HttpClientModule} from '@angular/common/http';
import {AutocompleteModule} from 'ng2-input-autocomplete';
import {AdminModule} from './AdminModule/admin.module';
import {PATHGRAPHQL, SOCKETIO} from './variables';

import {CollapseModule} from 'ngx-bootstrap/collapse';
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {NgxSpinnerModule} from 'ngx-spinner';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {ComisionesModule} from './ComisionesModule/comisiones.module';
import {ReportesModule} from './ReportesModule/reportes.module';
import {ChartsModule} from 'ng2-charts';
import {SocketIoConfig, SocketIoModule} from 'ngx-socket-io';
import {RvgModule} from './RVGModule/rvg.module';
import {setContext} from 'apollo-link-context';
import {UUIDLOCALSTORAGE} from '../config';
import {ApolloLink} from 'apollo-link';


const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
};

const config: SocketIoConfig = {url: SOCKETIO, options: {
    transports:["websocket"]
  }};


export function createApollo(httpLink: HttpLink) {

  const basic = setContext((operation, context)=>({
    headers:{
      Accept:'charset=utf-8'
    }
  }))
  const token = localStorage.getItem(UUIDLOCALSTORAGE);
  const auth = setContext((operation, context)=>({
    headers:{
      Authorization: `Bearer ${token}`
    }
  }));

  const link = ApolloLink.from([basic, auth, httpLink.create({uri:PATHGRAPHQL})])

  return {
    link,
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions
  };
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonModule,
    ApolloModule,
    HttpLinkModule,
    AppRoutingModule,
    CoreModule,
    AdminModule,
    FriedmanModule,
    ComisionesModule,
    ReportesModule,
    RvgModule,
    AutocompleteModule.forRoot(),
    CollapseModule.forRoot(),
    AccordionModule.forRoot(),
    NgxSpinnerModule,
    NgxChartsModule,
    ChartsModule,
    SocketIoModule.forRoot(config)
  ],
  providers: [{
    provide: APOLLO_OPTIONS,
    useFactory: createApollo,
    deps: [HttpLink]
  }],
  bootstrap: [AppComponent]
})
export class AppModule {
}
